module.exports = __webpack_public_path__ + "kudos_86.svg?bfee1203758246c91c27b0de1a83c9e3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_86.svg
// module id = 190
// module chunks = 0